<template>
  <HomeSection
    v-if="featuredProjects.length"
    title="Selected Work"
    link="/projects/"
  >
    <div class="projects-grid">
      <PageLinkCard
        v-for="project in featuredProjects"
        :key="project.url"
        :item="project"
        :image="project.cover_image"
        link-text="View project"
      />
    </div>
  </HomeSection>
</template>

<script setup lang="ts">
import { data as projects } from "../../../../projects/index.data.js";
import HomeSection from "./HomeSection.vue";
import PageLinkCard from "./PageLinkCard.vue";

// The loader already sorts newest-first, so the homepage just takes the head.
// Four keeps the grid to at most two full rows; "View All" carries the rest.
const featuredProjects = projects.slice(0, 4);
</script>

<style scoped lang="scss">
@use "../../styles/abstracts/breakpoints" as *;

.projects-grid {
  display: grid;
  gap: 2rem;

  @include lg {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
}
</style>
